import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal'

export const ModalStyled = styled(Modal)`

  &.modal-md .modal-dialog {
    max-width: 610px !important;
  }

  

  .modal-dialog{
    @media (min-width: 576px) {
      max-width: 98%;
    }
  
    @media (min-width: 1140px) {
      max-width: 1140px;
    }

    .modal-content {
      background-color: $inactive;
      border-radius: 6px;
      padding: 2rem;

      .modal-header {
        border: 0;
        padding: 0;
        padding-bottom: 2rem;

        &.warning{
          .modal-title{
            color: #BF3939;
            line-height: 32px;
          }
        }

        .modal-title {
          font-family: 'Gotham';
          font-weight: bold;
          font-size: 24px;
          line-height: 40px;
          color: #475466;
      
          span{
            display: block;                  
            font-size: 12px;
            line-height: 14px;
            color: #98A2B2;
          }
        }

        .close {
          background-color: #4A90E2;
          color: #fff;
          opacity: 1;
          outline: 0;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          font-size: 18px;
          text-align: center;
          padding: 0;
          margin: 0;
          
          span{
            display: block;
            margin-top: -4px;
          }
          
        }
      }

      .modal-body {
        padding: 0;

        .simple-text{
          font-weight: 500;
          font-size: 12px;
          line-height: 18px;
          color: #98A2B2;
          margin-bottom: 30px;
          text-align: left;
        }

        label {
          font-size: 12px;
          line-height: 14px;
        }

        span{
          font-style: normal;
          font-weight: 900;
          font-size: 12px;
          line-height: 14px;
          color: #7A8799;
        }
      }

      .modal-footer {
        border-top: 1px solid #E4E9F0;
        padding: 0;
        padding-top: 20px;
        margin-top: 20px;

        .txt-extra {
          font-weight: 500;
          font-size: 10px;
          line-height: 22px;
          color: #98A2B2;
          margin-right: auto;

        }
      }

      .talign-center{
    text-align: center;
        }
    }
  }
`;